<template>
    <span v-if="isShow" class="chime-tax-status"  :class="[theme,{sold:isSold}]">
        <i>+TX</i>
    </span>
</template>
<script>
// CHIME-36898  $ft.formatCurrency 
let mlsId = [526, 726];
export default {
    name: "chime-tax-status",
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        },
        theme: {
            type: String,
            default: "standard"
        },
        isSold: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isShow({ info }) {
            if (mlsId.includes(info.mlsOrgId) && info.chimeTaxStatus) {
                return  true
            }
            return  false
        }
    }
}

</script>
<style lang="scss">
.chime-tax-status{
    font-size: 11px;
    display: inline-block;
    vertical-align: middle;
    width: 40px;
    padding-left: 5px;
    i{
        background: #51566626;
        color: #515666;
        height: 17px;
        padding: 0 6px;
        line-height: 17px;
        border-radius: 9px;
        font-style: normal;
        vertical-align: top;
        font-weight: normal;
    }
    &.standard{
        

    }
}
</style>